export class IndexOutOfBoundsError extends Error {
    index;
    size;
    constructor(index, size) {
        super(`Index out of bounds: Index ${index}, size: ${size}`);
        this.name = "IndexOutOfBoundsError";
        this.index = index;
        this.size = size;
        Object.setPrototypeOf(this, IndexOutOfBoundsError.prototype);
    }
}
export default IndexOutOfBoundsError;
